<script>
export default {
  name: 'UlFormBtn',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>
<template>
  <button
    type="button"
    class="ul-form-btn"
    :disabled="disabled"
    :title="title"
    @click="$emit('click')"
  >
    <i :class="icon"></i>
  </button>
</template>
<style lang="scss">
  .ul-form-btn {
    color: #333333;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: none;
    transition: .3s;
    font-size: 16px;
    outline: none;
    margin: 0 0 0 4px;
    border-radius: 50%;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    &:active {
      background-color: rgba(0, 0, 0, .1);
    }

    &:focus {
      background-color: rgba(0, 0, 0, .12);
    }
  }
</style>
